import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { shopCatalogActions } from './catalog.actions';
import { shopCatalogState } from './catalog.state';
import { DNAProductsQuery, ProductGroupQuery } from './catalog.state.interface';

export const shopCatalogReducer = createReducer(
  shopCatalogState,
  on(shopCatalogActions.fetchProductGroups, (state, payload) => {
    const productGroupQuery: ProductGroupQuery = {
      ...state.productGroupQuery,
      loading: true,
      error: undefined,
      pagination: {
        ...state.productGroupQuery.pagination,
        page: payload.page
      }
    };
    if (payload.reset) {
      productGroupQuery.count = 0;
    }
    return {
      ...state,
      productGroupQuery
    };
  }),
  on(shopCatalogActions.fetchProductGroupsSuccess, (state, payload) => {
    const productGroupQuery: ProductGroupQuery = {
      ...state.productGroupQuery,
      loading: false,
      error: undefined,
      pagination: {
        ...state.productGroupQuery.pagination,
        totalItems: payload.totalItems
      }
    };

    const entities = cloneDeep(productGroupQuery.entities);
    const idsByPage = cloneDeep(productGroupQuery.idsByPage);
    productGroupQuery.count += 1;

    for (const entity of payload.items) {
      if (!entity.id) continue;

      entities[entity.id] = entity;

      const currentPageIds = idsByPage[payload.page] as
        | Array<string>
        | undefined;
      if (currentPageIds) {
        const prevIndex = idsByPage[payload.page].findIndex(
          (idItem) => idItem === entity.id
        );
        if (prevIndex >= 0) {
          idsByPage[payload.page][prevIndex] = entity.id;
        } else {
          idsByPage[payload.page].push(entity.id);
        }
      } else {
        idsByPage[payload.page] = [entity.id];
      }
    }
    const ids: Array<string> = [];
    for (const idsPerPage of Object.keys(idsByPage).map(
      (page) => idsByPage[page]
    )) {
      ids.push(...idsPerPage);
    }
    productGroupQuery.ids = ids;
    productGroupQuery.entities = entities;
    productGroupQuery.idsByPage = idsByPage;

    return {
      ...state,
      productGroupQuery
    };
  }),
  on(shopCatalogActions.fetchProductGroupsFailed, (state, payload) => {
    const productGroupQuery: ProductGroupQuery = {
      ...state.productGroupQuery,
      loading: false,
      error: payload.error,
      count: state.productGroupQuery.count + 1
    };

    return {
      ...state,
      productGroupQuery
    };
  }),
  on(shopCatalogActions.resetProductGroups, (state) => ({
    ...state,
    productGroupQuery: {
      ...state.productGroupQuery,
      entities: {},
      ids: [],
      idsByPage: {}
    }
  })),
  on(shopCatalogActions.setDNAProductsQueryLimit, (state, payload) => ({
    ...state,
    dnaProductsQuery: {
      ...state.dnaProductsQuery,
      limit: payload.limit
    }
  })),
  on(shopCatalogActions.fetchDNAProducts, (state, payload) => {
    const dnaProductsQuery: DNAProductsQuery = {
      ...state.dnaProductsQuery,
      loading: true,
      error: undefined,
      pagination: {
        ...state.dnaProductsQuery.pagination,
        page: payload.page
      }
    };
    if (payload.reset) {
      dnaProductsQuery.count = 0;
    }
    return {
      ...state,
      dnaProductsQuery,
      productGroupDNAQuery: {
        ...state.productGroupDNAQuery,
        loading: true,
        error: undefined
      }
    };
  }),
  on(shopCatalogActions.fetchDNAProductsSuccess, (state, payload) => {
    const dnaProductsQuery: DNAProductsQuery = {
      ...state.dnaProductsQuery,
      loading: false,
      error: undefined,
      pagination: {
        ...state.dnaProductsQuery.pagination,
        totalItems: payload.totalItems
      }
    };

    const entities = cloneDeep(dnaProductsQuery.entities);
    const idsByPage = cloneDeep(dnaProductsQuery.idsByPage);
    dnaProductsQuery.count += 1;

    for (const entity of payload.items) {
      if (!entity.id) continue;

      entities[entity.id] = entity;

      const currentPageIds = idsByPage[payload.page] as
        | Array<string>
        | undefined;
      if (currentPageIds) {
        const prevIndex = idsByPage[payload.page].findIndex(
          (idItem) => idItem === entity.id
        );
        if (prevIndex >= 0) {
          idsByPage[payload.page][prevIndex] = entity.id;
        } else {
          idsByPage[payload.page].push(entity.id);
        }
      } else {
        idsByPage[payload.page] = [entity.id];
      }
    }
    const ids: Array<string> = [];
    for (const idsPerPage of Object.keys(idsByPage).map(
      (page) => idsByPage[page]
    )) {
      ids.push(...idsPerPage);
    }
    dnaProductsQuery.ids = ids;
    dnaProductsQuery.entities = entities;
    dnaProductsQuery.idsByPage = idsByPage;

    return {
      ...state,
      dnaProductsQuery
    };
  }),
  on(shopCatalogActions.fetchDNAProductsFailed, (state, payload) => {
    const dnaProductsQuery: DNAProductsQuery = {
      ...state.dnaProductsQuery,
      loading: false,
      error: payload.error,
      count: state.productGroupQuery.count + 1
    };

    return {
      ...state,
      dnaProductsQuery
    };
  }),
  on(shopCatalogActions.fetchProductGroupsSuccess, (state, payload) => {
    const productGroupQuery: ProductGroupQuery = {
      ...state.productGroupQuery,
      loading: false,
      error: undefined,
      pagination: {
        ...state.productGroupQuery.pagination,
        totalItems: payload.totalItems
      }
    };

    const entities = cloneDeep(productGroupQuery.entities);
    const idsByPage = cloneDeep(productGroupQuery.idsByPage);
    productGroupQuery.count += 1;

    for (const entity of payload.items) {
      if (!entity.id) continue;

      entities[entity.id] = entity;

      const currentPageIds = idsByPage[payload.page] as
        | Array<string>
        | undefined;
      if (currentPageIds) {
        const prevIndex = idsByPage[payload.page].findIndex(
          (idItem) => idItem === entity.id
        );
        if (prevIndex >= 0) {
          idsByPage[payload.page][prevIndex] = entity.id;
        } else {
          idsByPage[payload.page].push(entity.id);
        }
      } else {
        idsByPage[payload.page] = [entity.id];
      }
    }
    const ids: Array<string> = [];
    for (const idsPerPage of Object.keys(idsByPage).map(
      (page) => idsByPage[page]
    )) {
      ids.push(...idsPerPage);
    }
    productGroupQuery.ids = ids;
    productGroupQuery.entities = entities;
    productGroupQuery.idsByPage = idsByPage;

    return {
      ...state,
      productGroupQuery
    };
  }),
  on(shopCatalogActions.fetchProductGroupsFailed, (state, payload) => {
    const productGroupQuery: ProductGroupQuery = {
      ...state.productGroupQuery,
      loading: false,
      error: payload.error,
      count: state.productGroupQuery.count + 1
    };

    return {
      ...state,
      productGroupQuery
    };
  }),
  on(shopCatalogActions.fetchProductGroupDNASuccess, (state, payload) => {
    return {
      ...state,
      productGroupDNAQuery: {
        ...state.productGroupDNAQuery,
        loading: false,
        error: undefined,
        result: payload.result
      }
    };
  }),
  on(shopCatalogActions.fetchProductGroupDNAFailed, (state, payload) => {
    return {
      ...state,
      productGroupDNAQuery: {
        ...state.productGroupDNAQuery,
        loading: false,
        error: payload.error
      }
    };
  })
);
